import { render, staticRenderFns } from "./message-revoked.vue?vue&type=template&id=69444cdc&scoped=true"
import script from "./message-revoked.vue?vue&type=script&lang=ts"
export * from "./message-revoked.vue?vue&type=script&lang=ts"
import style0 from "./message-revoked.vue?vue&type=style&index=0&id=69444cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69444cdc",
  null
  
)

export default component.exports